"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-dropdown viewbox="0 0 24 13"><path d="M11.604 12.921L0 0h23.215l-5.807 6.462z"></path></symbol>';
};